export default __webpack_public_path__ + "static/media/jCHF.44be58c0.png";